document.addEventListener('DOMContentLoaded', () => {
    // Modal Section
    // const modal = document.getElementById('iframe-modal');
    // const openModalButton = document.getElementById('open-iframe-modal');
    // const closeModalButton = modal.querySelector('.iframe-modal-close');

    // if (openModalButton && modal && closeModalButton) {
    //     // Open modal
    //     openModalButton.addEventListener('click', () => {
    //         console.log('Open Soundscope button clicked'); // Debugging log
    //         modal.style.display = 'block';
    //     });

    //     // Close modal
    //     closeModalButton.addEventListener('click', () => {
    //         modal.style.display = 'none';
    //     });

    //     // Close modal when clicking outside the content
    //     window.addEventListener('click', (event) => {
    //         if (event.target === modal) {
    //             modal.style.display = 'none';
    //         }
    //     });
    // } else {
    //     console.error('Modal or open button not found'); // Debugging log
    // }

    // // Handle iframe modals for multiple buttons
    // const iframeModal = document.getElementById('iframe-modal');
    // const openModalButtons = [
    //     document.getElementById('open-iframe-modal'),
    //     document.getElementById('open-iframe-modal2')
    // ];
    // const closeModalButtonIframe = iframeModal.querySelector('.iframe-modal-close');

    // if (iframeModal && closeModalButtonIframe) {
    //     // Open modal for each button
    //     openModalButtons.forEach(button => {
    //         if (button) {
    //             button.addEventListener('click', () => {
    //                 console.log(`${button.id} clicked`); // Debugging log
    //                 iframeModal.style.display = 'block';
    //             });
    //         }
    //     });

    //     // Close modal
    //     closeModalButtonIframe.addEventListener('click', () => {
    //         iframeModal.style.display = 'none';
    //     });

    //     // Close modal when clicking outside the content
    //     window.addEventListener('click', (event) => {
    //         if (event.target === iframeModal) {
    //             iframeModal.style.display = 'none';
    //         }
    //     });
    // } else {
    //     console.error('Iframe modal or close button not found'); // Debugging log
    // }

    // Generalized Input Validation Section
    function setupValidation(modalId) {
        const modal = document.getElementById(modalId);
        if (!modal) return;

        const firstNameInput = modal.querySelector('input[name="FNAME"]');
        const emailInput = modal.querySelector('input[name="EMAIL"]');
        const subscribeButton = modal.querySelector('input[type="submit"]');

        if (firstNameInput && emailInput && subscribeButton) {
            function validateInputs() {
                const isFirstNameValid = firstNameInput.value.trim() !== '';
                const isEmailValid = emailInput.value.trim() !== '' && emailInput.checkValidity();
                subscribeButton.disabled = !(isFirstNameValid && isEmailValid);
            }

            firstNameInput.addEventListener('input', validateInputs);
            emailInput.addEventListener('input', validateInputs);
        }
    }

    // Apply validation to all modals
    setupValidation('android-soon-modal');
    setupValidation('replaceable-modal');
    setupValidation('audiologist-modal');

    // Function to check if an element is in the viewport
    function isInViewport(element) {
        const rect = element.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    // Handle video playback based on visibility
    const scrollingVideos = document.querySelectorAll('.product-scrolling-video');
    const otherVideo = document.querySelector('.other2-right video');

    function handleVideoPlayback() {
        scrollingVideos.forEach(video => {
            if (isInViewport(video)) {
                if (video.paused) {
                    video.play();
                }
            } else {
                if (!video.paused) {
                    video.pause();
                }
            }
        });

        if (otherVideo) {
            if (isInViewport(otherVideo)) {
                if (otherVideo.paused) {
                    otherVideo.play();
                }
            } else {
                if (!otherVideo.paused) {
                    otherVideo.pause();
                }
            }
        }
    }

    // Add event listeners for scrolling and resizing
    window.addEventListener('scroll', handleVideoPlayback);
    window.addEventListener('resize', handleVideoPlayback);

    // Initial check
    handleVideoPlayback();

    // Press Modal
    document.querySelectorAll('press ul button').forEach((button) => {
        button.addEventListener('click', () => {
            const img = button.querySelector('img'); // Get the <img> inside the button
            const type = img.getAttribute('data-type');
            const src = img.getAttribute('data-src');
            const modal = document.createElement('div');
            modal.className = 'press-modal';

            let content = '';
            if (type === 'video') {
                content = `
                    <video controls autoplay>
                        <source src="${src}" type="video/mp4">
                        Your browser does not support the video tag.
                    </video>
                `;
            } else if (type === 'youtube') {
                content = `
                    <iframe width="560" height="315" src="${src}" frameborder="0" allowfullscreen></iframe>
                `;
            } else if (type === 'iframe') {
                content = `
                    <iframe src="${src}" width="100%" height="500px" frameborder="0"></iframe>
                `;
            } else if (type === 'vimeo') {
                content = `
                    <iframe src="${src}" width="100%" height="500px" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
                `;
            }

            modal.innerHTML = `
                <div class="press-modal-content">
                    <span class="close">&times;</span>
                    ${content}
                    <button class="close-bottom">Close</button>
                </div>
            `;
            document.body.appendChild(modal);

            // Close modal when clicking the top-right close button
            modal.querySelector('.close').addEventListener('click', () => {
                document.body.removeChild(modal);
            });

            // Close modal when clicking the bottom close button
            modal.querySelector('.close-bottom').addEventListener('click', () => {
                document.body.removeChild(modal);
            });

            // Close modal when clicking outside the modal content
            modal.addEventListener('click', (event) => {
                if (event.target === modal) {
                    document.body.removeChild(modal);
                }
            });
        });
    });

    // Replay video in .learninfo-right-item[data-index="2"] when it becomes visible
    const rightItem2 = document.querySelector('.learninfo-right-item[data-index="2"]');
    const video2 = rightItem2?.querySelector('video');

    if (rightItem2 && video2) {
        const observer = new window.IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        video2.currentTime = 0;
                        video2.play().catch(() => {});
                    }
                });
            },
            { threshold: 0.5 } // 50% visible triggers replay
        );
        observer.observe(rightItem2);
    }

    // Synchronize scrolling text with media rotation
    // const leftItems = document.querySelectorAll('learninfo .learninfo-left-item');
    // const rightItems = document.querySelectorAll('learninfo .learninfo-right-item');
    // const leftContainer = document.querySelector('learninfo .learninfo-left');

    /*function updateActiveMedia() {
        //console.time('[learn.js] updateActiveMedia');
        const scrollTop = leftContainer.scrollTop;
        const totalHeight = leftContainer.scrollHeight - leftContainer.clientHeight;
        const scrollPercentage = scrollTop / totalHeight;

        let activeIndex = Math.round(scrollPercentage * (leftItems.length - 1));

        // Debug: Log which media is active
        //console.log('[learn.js] updateActiveMedia: scrollTop', scrollTop, 'activeIndex', activeIndex);

        // Ensure the first item is active at the start and the last item at the end
        if (scrollTop === 0) {
            activeIndex = 0;
        } else if (scrollTop >= totalHeight) {
            activeIndex = leftItems.length - 1;
        }

        rightItems.forEach((item, index) => {
            const video = item.querySelector('video');
            item.classList.toggle('active', index === activeIndex);

            // Handle video autoplay and pause logic
            if (video) {
                if (index === 2 && index === activeIndex) {
                    video.play(); // Autoplay video for data-index=2
                } else if (index === 2) {
                    video.pause(); // Pause video when not active
                } else if (index === 3) {
                    video.pause(); // Ensure video with data-index=3 is paused by default
                }
            }
        });
        //console.timeEnd('[learn.js] updateActiveMedia');
    }

    // Initialize the first media item as active
    updateActiveMedia();*/

    /*if(leftContainer) {
        function isElementInViewport(el) {
            const rect = el.getBoundingClientRect();
            return (
                rect.top < window.innerHeight &&
                rect.bottom > 0
            );
        }

        function canScrollDown(el, deltaY) {
            // Only intercept if scrolling down and not at bottom
            return deltaY > 0 && el.scrollTop + el.clientHeight < el.scrollHeight;
        }

        function handleWheel(e) {
            if (!isElementInViewport(leftContainer)) return;
            if (canScrollDown(leftContainer, e.deltaY)) {
                e.preventDefault();
                leftContainer.scrollTop += e.deltaY
            }
            // If scrolling up or at boundary, allow page scroll
        }

        // Touch support
        let touchStartY = null;
        function handleTouchStart(e) {
            if (!isElementInViewport(leftContainer)) return;
            if (e.target.closest('.product-scolling-view')) {
                touchStartY = e.touches[0].clientY;
            }
        }

        function handleTouchMove(e) {
            if (!isElementInViewport(leftContainer) || touchStartY === null) return;
            const touchY = e.touches[0].clientY;
            const deltaY = touchStartY - touchY;
            if (deltaY > 0 && leftContainer.scrollTop + leftContainer.clientHeight < leftContainer.scrollHeight) {
                // Only intercept if swiping up (scrolling down)
                e.preventDefault();
                leftContainer.scrollTop += deltaY
            }
            // If swiping down (scrolling up), allow page scroll
            touchStartY = touchY;
        }

        function handleTouchEnd() {
            touchStartY = null;
        }
    }

    // Add scroll event listener
    window.addEventListener('wheel', handleWheel, { passive: false });
    window.addEventListener('touchstart', handleTouchStart, { passive: false });
    window.addEventListener('touchmove', handleTouchMove, { passive: false });
    window.addEventListener('touchend', handleTouchEnd, { passive: false });*/
    //leftContainer.addEventListener('scroll', updateActiveMedia);

    // Allow manual play for video with data-index=3
    const manualPlayVideoContainer = document.querySelector('.learninfo-right-item[data-index="3"]');
    const manualPlayVideo = manualPlayVideoContainer?.querySelector('video');
    const videoInstructions1 = manualPlayVideoContainer?.querySelector('.video-instructions1');
    const videoInstructions2 = manualPlayVideoContainer?.querySelector('.video-instructions2');

    if (manualPlayVideoContainer && manualPlayVideo && videoInstructions1 && videoInstructions2) {
        // Update instructions visibility based on video state
        function updateVideoInstructions() {
            if (manualPlayVideo.paused) {
                videoInstructions1.style.display = 'block'; // Show "Tap to play"
                videoInstructions2.style.display = 'none';  // Hide "Tap to pause"
            } else {
                videoInstructions1.style.display = 'none';  // Hide "Tap to play"
                videoInstructions2.style.display = 'block'; // Show "Tap to pause"
            }
        }

        // Add event listeners to update instructions on play/pause
        manualPlayVideo.addEventListener('play', updateVideoInstructions);
        manualPlayVideo.addEventListener('pause', updateVideoInstructions);

        // Initialize instructions visibility
        updateVideoInstructions();

        // Add click event to toggle video playback
        manualPlayVideoContainer.addEventListener('click', () => {
            if (manualPlayVideo.paused) {
                manualPlayVideo.muted = false; // Unmute the video
                manualPlayVideo.play().catch((err) => {
                    console.error('Video play failed:', err);
                });
            } else {
                manualPlayVideo.pause();
            }
        });

        // Add event listeners
        manualPlayVideo.addEventListener('play', () => {
            const overlayText = manualPlayVideoContainer.querySelector('.video-overlay');
            if (overlayText) overlayText.textContent = 'Tap to pause'; // Update text when playing
        });
        manualPlayVideo.addEventListener('pause', () => {
            const overlayText = manualPlayVideoContainer.querySelector('.video-overlay');
            if (overlayText) overlayText.textContent = 'Tap to play'; // Update text when paused
        });
    } else {
        console.error('Video container, video element, or instructions not found for data-index=3');
    }
});

